import { render, staticRenderFns } from "./RmpLegalEntityDetails.vue?vue&type=template&id=7de5fc3e"
import script from "./RmpLegalEntityDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpLegalEntityDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports